// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
// import bootstrap from "bootstrap";
// import Parallax from 'parallax-js'
import $ from "jquery";
window.jQuery = $;
window.$ = $;
require ('jquery-parallax.js');
var Masonry = require('masonry-layout');
import mediumZoom from 'medium-zoom';
require('paroller.js');
import 'slick-carousel';
// import WOW from'wowjs'
// const WOW = require('wowjs');

const svgClose = `
<svg class="navbar-toggler-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="24" height="24">
  <path stroke="white" stroke-width="2" d="M5 5 L25 25"/>
  <path stroke="white" stroke-width="2" d="M25 5 L5 25"/>
</svg>`;

// import simpleParallax from 'simple-parallax-js';


const bootstrap = window.bootstrap = require('bootstrap');
// var parallax_images = document.getElementsByClassName('parallax');
// new simpleParallax( parallax_images,{
//     overflow: false
//     // scale: 1.05
//     // orientation: 'right'
// });

var stickyHeaderHeight = 200 ;

if(document.querySelector('.grid')){
    var msnry = new Masonry( '.grid', {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
}





function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}


document.addEventListener('DOMContentLoaded', function() {
  // Sélectionne uniquement les radios CF7 (évite d'affecter d'autres radios)
  const radios = document.querySelectorAll('.wpcf7 input[type="radio"]');

  radios.forEach((radio, index) => {
    const origLabel = radio.closest('label');
    if (!origLabel) return; // sécurité

    const parent = origLabel.parentNode;
    const text = origLabel.textContent.trim();
    const id = `cf7-radio-${radio.name.replace(/\s+/g,'-')}-${index}`;

    // Crée un conteneur propre
    const container = document.createElement('span');
    container.className = 'wpcf7-list-item d-inline-block';

    // Prépare l'input (on le déplace)
    radio.classList.add('btn-check');
    radio.id = id;
    radio.setAttribute('autocomplete', 'off');

    // Crée le label Bootstrap (le bouton visible)
    const btnLabel = document.createElement('label');
    btnLabel.className = 'btn d-block btn-outline-secondary btn-lg m-3';
    btnLabel.htmlFor = id;
    btnLabel.textContent = text;

    // Insère input puis label (input doit être IMMEDIATEMENT avant le label)
    container.appendChild(radio);
    container.appendChild(btnLabel);

    // Remplace le label CF7 original par notre container
    parent.replaceChild(container, origLabel);

    // --- Gestion initiale de l'état actif (si checked par défaut) ---
    if (radio.checked) {
      btnLabel.classList.remove('btn-outline-secondary');
      btnLabel.classList.add('btn-secondary');
    }

    // --- Gestion au changement : met à jour tous les boutons du même group (même name) ---
    radio.addEventListener('change', function() {
      // parcourt toutes les radios du même name
      document.querySelectorAll(`input[name="${radio.name}"]`).forEach(r => {
        const lbl = document.querySelector(`label[for="${r.id}"]`);
        if (!lbl) return;
        if (r.checked) {
          lbl.classList.remove('btn-outline-secondary');
          lbl.classList.add('btn-secondary');
        } else {
          lbl.classList.remove('btn-secondary');
          lbl.classList.add('btn-outline-secondary');
        }
      });
    });
  });
});



$(function() { 

    $('.cookies_settings a').on('click', function(){
        window.Didomi.preferences.show();
        return false ;
    });


    $('.slick-solo').slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToShow: 1,
        slidesToScroll : 1,
        arrows: false,
        adaptiveHeight: true
        //responsive: slick_responsive,
        //prevArrow: slickArrows.prev.red,
        //nextArrow: slickArrows.next.red,
    });

     /**
     * Anchor smooth scroll
     */
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .on('click', function(event) {
          // On-page links
          if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
              && 
              location.hostname == this.hostname
          ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  document.documentElement.scrollTo({
                      top: target.offset().top - stickyHeaderHeight,
                      behavior: "smooth"
                  })
              }
          }
      });

    $('.accordion-collapse').on('shown.bs.collapse', function (e) {
        var $panel = $(this).closest('.accordion-item');
        document.documentElement.scrollTo({
            top: $panel.offset().top - stickyHeaderHeight,
            behavior: "smooth"
        });
    });

    //Clone burger icon to overlay menu
    $('.navbar-fixed-opened').on('show.bs.collapse', function () {
        $('.navbar-closer').remove();
        $('.navbar-fixed-opened').prepend(`<button class="navbar-toggler navbar-closer" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="true" aria-label="Fermer">
        ${svgClose}</button>`);
    }) ;

    // Close menu & overlays when Escape
    $(document).on('keydown', function(e) {
        if (e.key == "Escape") {
            $('#navbarMain').collapse('hide');
            $('.agencea-overlay').removeClass('shown');
        }
    });

    //Wow
    if('function' === typeof WOW){
        new WOW().init();
    }
    

    // Sticky menu
    if (window.matchMedia("(min-width: 768px)").matches) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 160) {
                $('#header').addClass('shadow')
            } else {
                 $('#header').removeClass('shadow')
            } 
        });
    }

    // $('.dropdown-toggle').dropdown();
    mediumZoom('[data-zoomable]');
    $("[data-paroller-factor]").wrap('<div class="paroller-wrap"></div>');
    $("[data-paroller-factor]").paroller();
    

    // jarallaxVideo();
    // jarallax(document.querySelectorAll('.jarallax'), {
    //     speed: 0.2
    // });

    // Menu
    $(".dropdown").hover(function(){
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")){
            dropdownMenu.parent().toggleClass("open");
        }
    });


    $(document).on('click', '.navbar .dropdown-toggle', function(){
        if (window.matchMedia("(min-width: 992px)").matches) {
            window.location.href= $(this).attr('href');
        }
    });

    // Search form full screen [search_full_screen]
    $(document).on('click', '#search-full-screen__toggle', function(){
        $('#search-full-screen__target')
            .prepend(`<button class="navbar-toggler agencea-overlay__close" type="button" aria-controls="search-full-screen__form" aria-expanded="true" aria-label="Fermer">
        ${svgClose}</button>`)
            .addClass('shown');
    });

    $(document).on('click', '.agencea-overlay__close', function(){
        $('.agencea-overlay')
            .removeClass('shown')
            .find('.agencea-overlay__close').remove();
           
    });
   



    // Counters
    $(window).on('scroll', function(){
        $('.count, .down_count').each(function () {
            if(isInViewport($(this)[0])){
                $(this).addClass('countAnimated');
            }
        });

        $('.count.countAnimated:not(.stopped)').each(function () {
                $(this).css('opacity', 1);
                $(this).prop('Counter',0).animate({
                    Counter: $(this).text()
                }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
                $(this).addClass('stopped');
        });

        // Down Counters
        $('.down_count.countAnimated:not(.stopped)').each(function () {
                $(this).css('opacity', 1);
                $(this).prop('Counter',10).animate({
                    Counter: $(this).text()
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
                $(this).addClass('stopped');
        });
    });
      


   //Scroll back to top
		
		var progressPath = document.querySelector('.progress-wrap path');
        if(progressPath){
            var pathLength = progressPath.getTotalLength();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
            progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
            progressPath.style.strokeDashoffset = pathLength;
            progressPath.getBoundingClientRect();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
            var updateProgress = function () {
                var scroll = $(window).scrollTop();
                var height = $(document).height() - $(window).height();
                var progress = pathLength - (scroll * pathLength / height);
                progressPath.style.strokeDashoffset = progress;
            }
            updateProgress();
            $(window).scroll(updateProgress);	
            var offset = 150;
            // var duration = 550;
            jQuery(window).on('scroll', function() {
                if (jQuery(this).scrollTop() > offset) {
                    jQuery('.progress-wrap').addClass('active-progress');
                } else {
                    jQuery('.progress-wrap').removeClass('active-progress');
                }
            });				
            jQuery('.progress-wrap').on('click', function(event) {
                event.preventDefault();
                document.documentElement.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
                return false;
            });
        }


    /**
     * Map dealers
     */

    if($('#contact_map').length > 0){
    

        $.post(agencea.ajaxurl, {'action':'geocode_contact_address'}, function(response){
            if(response.lat_lng != ""){
                var contactmap = L.map('contact_map', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([response.lat_lng.lat, response.lat_lng.lng], 15);

                L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
                    maxZoom: 18,
                    // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                    //     'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: 'mapbox/streets-v11',
                    tileSize: 512,
                    zoomOffset: -1
                }).addTo(contactmap);
           
                var marker = L.marker([response.lat_lng.lat, response.lat_lng.lng], {title:response.name+'<br>'+response.address}).addTo(contactmap);
                marker.bindPopup(response.name+'<br>'+response.address).openPopup();
                    
            }
        
        });

       

        // $('.dealers-list > li').on('click', function(){
        //     var id = $(this).data('id') ;
        //     var _marker = dealersmap.getMarkerById(id);
        //     _marker.fire('click');
        // });
    }


    if($('#dealers').length > 0){
        // Get marker by ID
        L.Map.include({
            getMarkerById: function (id) {
                var marker = null;
                this.eachLayer(function (layer) {
                    if (layer instanceof L.Marker) {
                        if (layer.options.id === id) {
                            marker = layer;
                        }
                    }
                });
                return marker;
            }
        });


        var dealersmap = L.map('dealers', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([44.8947086,-0.2065675], 2);

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
            maxZoom: 18,
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1
        }).addTo(dealersmap);


        var markers = [] ;

        $.get('/wp-json/wp/v2/location', function(response){
            if(response.length > 0){
                for (let i = 0; i < response.length; i++) {
                    const element = response[i];
                    if(element.acf.coords.lat != '' && element.acf.coords.lng != ''){
                        var marker = L.marker([element.acf.coords.lat, element.acf.coords.lng], {title:element.title.rendered,id:element.id}).addTo(dealersmap);
                        marker.bindPopup(element.title.rendered).openPopup();
                        markers.push(marker);
                        marker.on('click', onClick);
                    }
                    
                }
                var group = new L.featureGroup(markers);
                dealersmap.fitBounds(group.getBounds());
            }
        
        });

        function onClick(e) {
            var id = e.target.options.id ;
            $('.dealers-list').find('li').removeClass('list-group-item-primary');
            $('.dealers-list').find('[data-id="'+id+'"]').addClass('list-group-item-primary');
            $('.dealers-list').find('[data-id="'+id+'"]').parents('.accordion-item').find('.accordion-button.collapsed').trigger('click');
        }

        $('.dealers-list > li').on('click', function(){
            var id = $(this).data('id') ;
            var _marker = dealersmap.getMarkerById(id);
            _marker.fire('click');
        });
    }

    
   
});





